import React from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { signOut } from "../../store/actions/authActions";
const SignedInLink = (props) => {
  const { name, initials } = props;

  return (
    <ul className="right">
      <li>
        <NavLink to="/newTask">New Task</NavLink>
      </li>
      <li>
        <a onClick={props.signOut}>Log Out</a>
      </li>
      <li>
        <NavLink to="/" className="btn btn-floating orange lighten-1 ">
          {initials}
        </NavLink>
      </li>
    </ul>
  );
};
const mapStateToProps = (state) => {
  return {
    name:
      state.firebase.profile["firstName"] +
      " " +
      state.firebase.profile["lastName"],
    initials: state.firebase.profile.initials,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(signOut()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SignedInLink);
